<svg
  [attr.width]="size"
  [attr.height]="size"
  viewBox="0 0 44 44">
  <circle
    class="frm-animated-logo__bg"
    cx="22"
    cy="22"
    r="20" />
  <circle
    class="frm-animated-logo__track"
    cx="22"
    cy="22"
    r="18"
    fill="none"
    stroke-width="1" />
  <g class="frm-animated-logo__ring-a">
    <circle
      class="frm-animated-logo__ring-a-stroke"
      cx="22"
      cy="22"
      r="18"
      fill="none"
      stroke-width="2"
      stroke-dasharray="56 58"
      stroke-linecap="round" />
  </g>
  <g class="frm-animated-logo__ring-b">
    <circle
      class="frm-animated-logo__ring-b-stroke"
      cx="22"
      cy="22"
      r="11"
      fill="none"
      stroke-width="1.5"
      stroke-dasharray="32 40"
      stroke-linecap="round" />
  </g>
  <text
    class="frm-animated-logo__label"
    x="22"
    y="26"
    text-anchor="middle"
    font-family="Montserrat,sans-serif"
    font-size="8.5"
    font-weight="800"
    letter-spacing="1">
    ФРМ
  </text>
</svg>
